import { iPhoneLink, iPadLink, androidLink, iPhoneHaikuSetup, iPadCantoSetup, androidHaikuSetup, twoFactorGuide } from './consts';

const blank = '_blank';

export const openiPhoneLink = () => {
    window.open(iPhoneLink, blank);
};

export const openiPadLink = () => {
    window.open(iPadLink, blank);
};

export const openAndroidLink = () => {
    window.open(androidLink, blank);
};

export const openiPhoneHaikuSetup = () => {
    window.location.href = iPhoneHaikuSetup;
};

export const openiPadCantoSetup = () => {
    window.location.href = iPadCantoSetup;
};

export const openAndroidHaikuSetup = () => {
    window.location.href = androidHaikuSetup;
};

export const download2FAGuide = () => {
    window.location.href = twoFactorGuide;
}